import { useContext } from "react";
import type { Props as ModalProps } from "~/components/Modal/Modal";
import {
	type ModalCloser,
	ModalContext,
	type ModalOpener,
} from "~/components/Modal/ModalProvider";

export const useModal = (): [ModalOpener, ModalCloser] => {
	const ctx = useContext(ModalContext);

	// eslint-disable-next-line @typescript-eslint/no-empty-function, @typescript-eslint/no-unused-vars
	const defaultOpen: ModalOpener = (_props: ModalProps) => {};

	// eslint-disable-next-line @typescript-eslint/no-empty-function
	const defaultClose: ModalCloser = () => {};

	return [ctx?.open ?? defaultOpen, ctx?.close ?? defaultClose];
};
